import { CancelSelectButton } from "../buttons/CancelSelectButton";
import { ClearMeasurementsButton } from "../buttons/ClearMeasurementsButton";
import { ColorizeButton } from "../buttons/ColorizeButton";
import { GroupSelectButton } from "../buttons/GroupSelectButton";
import { LayerSelectionButton } from "../buttons/LayerSelectionButton";
import { MeasureAreaButton } from "../buttons/MeasureAreaButton";
import { MeasureDistanceButton } from "../buttons/MeasureDistanceButton";
import { PrintButton } from "../buttons/PrintButton";
import { ToggleParcelsButton } from "../buttons/ToggleParcelsButton";
import { ZoomToSelectedButton } from "../buttons/ZoomToSelectedButton";
import { MeasureLayer } from "../layers/client/ClientLayers";
import { InspectionsLayer } from "../layers/selectable/InspectionsLayer";
import { Toolbar } from "../../lib/ui/toolbar";
export class GSAToolbar extends Toolbar {
    constructor(p_layer) {
        super({});
        let common_btns = [
            new ZoomToSelectedButton(),
            new MeasureDistanceButton(),
            new MeasureAreaButton(),
            new ClearMeasurementsButton(MeasureLayer),
            new LayerSelectionButton(),
            new GroupSelectButton().bind('singleton', 'set', 'toolbar', 'group'),
            new ColorizeButton(p_layer).bind('set'),
        ];
        let non_insp_btns = [
            new CancelSelectButton(p_layer).bind('set')
        ];
        let marker_btns = [
            new ToggleParcelsButton().bind('selection', 'edit')
        ];
        let print_btns = [
            new PrintButton()
        ];
        let btns = [...common_btns];
        if (!(p_layer instanceof InspectionsLayer))
            btns.push(...non_insp_btns);
        this.add_buttons(...btns, ...marker_btns, ...print_btns);
    }
}
